enum UserRole {
  SUPER_ADMIN = "super-admin",
  ADMIN = "admin",
  MANAGER = "manager",
  MANAGER_READER = "manager-reader",
}

export { UserRole };
